const metaPixelId = import.meta.env.VITE_META_PIXEL_ID?.trim();
const gaMeasurementId = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim();

const SESSION_KEYS = {
  formStart: 'byte_size_analytics_form_start',
  formView: 'byte_size_analytics_form_view',
};

export function initialiseAnalytics() {
  initialiseMetaPixel();
  initialiseGoogleAnalytics();
}

function initialiseMetaPixel() {
  if (!metaPixelId || window.fbq) return;
  /* Meta's standard loader, gated behind an environment variable. */
  ((f, b, e, v, n, t, s) => {
    if (f.fbq) return;
    n = f.fbq = function fbq() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', metaPixelId);
  window.fbq('track', 'PageView');
}

function initialiseGoogleAnalytics() {
  if (!gaMeasurementId || window.gtag) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaMeasurementId)}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', gaMeasurementId, { anonymize_ip: true });
}

function trackGoogleEvent(name, metadata = {}) {
  if (window.gtag) window.gtag('event', name, metadata);
}

function trackOncePerSession(key, event) {
  try {
    if (window.sessionStorage.getItem(key)) return;
    window.sessionStorage.setItem(key, 'yes');
  } catch {
    // Analytics should still work when storage is unavailable.
  }
  event();
}

export function trackFormView(metadata = {}) {
  const location = metadata.form_location || 'unknown';
  trackOncePerSession(`${SESSION_KEYS.formView}:${location}`, () => {
    trackGoogleEvent('lead_form_view', metadata);
  });
}

export function trackFormStart(metadata = {}) {
  trackOncePerSession(SESSION_KEYS.formStart, () => {
    trackGoogleEvent('lead_form_start', metadata);
    if (window.fbq) window.fbq('trackCustom', 'LeadFormStart', metadata);
  });
}

export function trackFormValidationError(metadata = {}) {
  trackGoogleEvent('lead_form_validation_error', metadata);
}

export function trackFormSubmitError(metadata = {}) {
  trackGoogleEvent('lead_form_submit_error', metadata);
}

export function trackLead(metadata = {}) {
  if (window.fbq) window.fbq('track', 'Lead', metadata);
  trackGoogleEvent('generate_lead', metadata);
}
